module.exports = __webpack_public_path__ + "img/ics_o_delivery_received.79cbed36.svg";